// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BHvD9","title":"Header_title__3-cN4","side":"Header_side__2AUut"};